<div class="content-container">
    <div><img src="assets/images/logo.png" alt="Site Logo"/></div>
    <div class="description-container">
        <div><img class="error-image" src="assets/images/404.svg" alt="Error"/></div>
        <div class="text-container"><h3>Page not found</h3><p>The page are looking for could not be found :(</p></div>
        <div><button mat-flat-button color="primary" routerLink="/"><mat-icon svgIcon="pq:undo"></mat-icon>Back To Home</button></div>
    </div>
</div>
<app-footer></app-footer>